/**
 * SHA-256 hex digest of raw bytes (matches fsds-be calculateChecksum).
 *
 * Used for course video chunked upload init (`contentHash` query param).
 * @see docs/features/course-video-upload-duplicate-detection.md
 */
export async function computeContentHash(buffer: ArrayBuffer): Promise<string> {
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer)
  return Array.from(new Uint8Array(hashBuffer))
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('')
}

/**
 * SHA-256 hex digest of file bytes (matches fsds-be calculateChecksum).
 */
export async function computeFileContentHash(file: Blob): Promise<string> {
  const buffer = await file.arrayBuffer()
  return computeContentHash(buffer)
}

export function isValidContentHash(contentHash: string): boolean {
  return /^[a-f0-9]{64}$/i.test(contentHash)
}
